import { gql } from '@apollo/client';

export interface ArrivedAtStartingPoint {
  taskId: string;
  appointmentId: string;
}

export const MARK_ARRIVED_AT_STARTING_POINT = gql`
  mutation MarkArrivedAtStartingPoint($input: ArrivedAtStartingPointInput!) {
    markArrivedAtStartingPoint(input: $input)
  }
`; 